/**
 * The ONE slot key (B4, 7w8f): the booking a deposit holds or is placed on —
 * its held booking, else the booking the link points at (a part-paid / firm
 * link, or one re-pointed by a resend, carries only `bookingId`). Every reader
 * that asks "which slot is this link for?" goes through here, so the sweep, a
 * cancel, the desk and the screens never disagree.
 */
export interface SlotKeyDeposit {
  heldBookingId?: string | null;
  bookingId?: string | null;
}

export function slotBookingId(d: SlotKeyDeposit): string | undefined {
  return d.heldBookingId ?? d.bookingId ?? undefined;
}
